// ------------------------------------
// FONTES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'css-variables';

    // Fonte textos
    function changeFontDefaultFamily() {
      const font = confTheme[ref]['font-default-family'];
      $root[0].style.setProperty('--font-default-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-default-family', changeFontDefaultFamily);

    // Fonte título
    function changeFontTitleFamily() {
      const font = confTheme[ref]['font-title-family'];
      $root[0].style.setProperty('--font-title-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-slug', changeFontTitleFamily);

    // Fonte botão
    function changeFontBtnFamily() {
      const font = confTheme[ref]['font-button-family'];
      $root[0].style.setProperty('--font-button-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-family', changeFontBtnFamily);

    // Estilo fonte texto
    function changeFontDefaultWeight() {
      const font = confTheme[ref]['font-default-weight'];
      $root[0].style.setProperty('--font-default-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-default-weight', changeFontDefaultWeight);

    // Estilo fonte título
    function changeFontTitleWeight() {
      const font = confTheme[ref]['font-title-weight'];
      $root[0].style.setProperty('--font-title-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-weight', changeFontTitleWeight);

    // Estilo fonte botão
    function changeFontBtnWeight() {
      const font = confTheme[ref]['font-button-weight'];
      $root[0].style.setProperty('--font-button-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-weight', changeFontBtnWeight);

    // Uppercase fonte título
    function changeFontTitleUppercase() {
      const value = confTheme[ref]['font-title-uppercase'];
      $root[0].style.setProperty('--font-title-uppercase', value);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-uppercase', changeFontTitleUppercase);

    // Uppercase fonte botão
    function changeFontBtnUppercase() {
      const value = confTheme[ref]['font-button-uppercase'];
      $root[0].style.setProperty('--font-button-uppercase', value);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-uppercase', changeFontBtnUppercase);
  }
})();
